'use client';

import { useEffect } from 'react';

import { apiGtm } from '@/api/gtm';
import { clearProductSizes } from '@/util/product-size-storage';

type OauthSuccessRedirectProps = {
  provider: string;
};

export function OauthSuccessRedirect({ provider }: OauthSuccessRedirectProps) {
  useEffect(() => {
    clearProductSizes();

    if (provider === 'tid') {
      const placement = window.sessionStorage.getItem('oauth:tbank:placement');
      const redirectUrl = window.sessionStorage.getItem('oauth:tbank:redirectUrl');

      apiGtm.login({
        placement: (placement as 'header' | 'cart') ?? 'header',
        method: 'tbank'
      });

      window.sessionStorage.removeItem('oauth:tbank:placement');
      window.sessionStorage.removeItem('oauth:tbank:redirectUrl');

      window.location.assign(
        redirectUrl?.startsWith('/') && !redirectUrl.startsWith('//')
          ? redirectUrl
          : '/account'
      );
      return;
    }

    window.location.assign('/account');
  }, [provider]);

  return null;
}
